import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";

const DirectFarmerPaymentForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();
  const chequeRef = useRef({});
  const [chequeDetails, setChequeDetails] = useState([]);
  const [chequeClose, setChequeClose] = useState(false);
  const { sendRequest: getGatePass } = useHttp();
  const bankTransferRef = useRef({});
  const [bankTransferDetails, setBankTransferDetails] = useState([]);
  const [bankTransferClose, setBankTransferClose] = useState(false);
  const [directFarmerPaymentId, setDirectFarmerPaymentId] = useState(false);

  const [directFarmerInvoiceId, setdirectFarmerInvoiceId] = useState();
  const [directFarmerInvoiceData, setdirectFarmerInvoicData] = useState([]);
  const [directFarmerInvoieProductdata, setdirectFarmerInvoieProductdata] =
    useState([]);
  const [currencyCode, setCurrencyCode] = useState(
    localStorage.getItem("currencyCode")
  );

  const [loading, setLoading] = useState(false);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const { sendRequest: postDirectPayment } = useHttp();

  const setCash = () => {
    if (frmRef.current.cash.checked) {
      frmRef.current.bank_transfer.disabled = true;
      frmRef.current.cheque.disabled = true;
      frmRef.current.cheque.checked = false;
      frmRef.current.bank_transfer.checked = false;
    } else {
      frmRef.current.bank_transfer.disabled = false;
      frmRef.current.cheque.disabled = false;
    }
  };
  const { sendRequest: getpassIdProc } = useHttp();
  const [gatepassId, setGatePassId] = useState();

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getDirectFarmerInvoice } = useHttp();

  useEffect(() => {
    getDirectFarmerInvoice(
      {
        url: `/api/DirectFarmerInvoiceForPayment/`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          setdirectFarmerInvoicData(res);
        }
      }
    );
  }, [getDirectFarmerInvoice]);

  const { sendRequest: gateprocRecieptdata } = useHttp();

  const { sendRequest: getFarmerInvoiceData } = useHttp();
  const { sendRequest: gatePass } = useHttp();

  const loadprocurmentData = (id) => {
    //console.log("load", id);
    setdirectFarmerInvoieProductdata([]);

    getFarmerInvoiceData(
      {
        url: `/api/DirectFarmerInvoiceProduct/?directFarmerInvoiceId=${id}`,
      },
      (res) => {
        console.log("DirectFarmerInvoiceProduct", res);
        setdirectFarmerInvoieProductdata(res.DirectFarmerInvoiceProduct);

        var itemlist = directFarmerInvoiceData.filter(
          (item) => parseInt(item.directFarmerInvoiceId) == parseInt(id)
        );

        console.log("itemlist", itemlist);

        frmRef.current.balanceAmount.value = itemlist[0].balanceAmount;
        frmRef.current.farmerName.value = itemlist[0].farmerName;

        frmRef.current.totalAmount.value = itemlist[0].totalAmount;
        frmRef.current.advanceAmount.value = itemlist[0].advanceAmount;
        frmRef.current.procurementRecieptNo.value =
          itemlist[0].procurementRecieptNo;

        frmRef.current.loadQuantity.value =
          itemlist[0].loadQuantity + " " + itemlist[0].unitAbbreviation;

        var procurementRecieptId = itemlist[0].procurementRecieptId;

        gateprocRecieptdata(
          {
            url: `/api/procurementReciept/?procurementRecieptId=${procurementRecieptId}`,
          },
          (res) => {
            if (res) {
              console.log("res", res);

              var gatepassId = res.gatepassId;

              console.log(gatepassId);

              gatePass(
                {
                  url: `/api/gatePass/?gatepassId=${gatepassId}`,
                },
                (resgetpass) => {
                  if (res) {
                    console.log("gatePass", resgetpass);
                    frmRef.current.contactnumber.value =
                      resgetpass.contactnumber;
                    frmRef.current.email.value = resgetpass.email;

                    frmRef.current.getpassNo.value = resgetpass.docNo;
                  }
                }
              );
            }
          }
        );
      }
    );
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (frmRef.current.cheque.checked) {
      if (chequeDetails.length == 0) {
        toast.error("Please enter at cheque details!");
        setChequeClose(true);
        return;
      }
    }
    if (frmRef.current.bank_transfer.checked) {
      if (bankTransferDetails.length == 0) {
        toast.error("Please enter at bank transfer details!");
        setBankTransferClose(true);
        return;
      }
    }

    if (
      frmRef.current.cash.checked == false &&
      frmRef.current.cheque.checked == false &&
      frmRef.current.bank_transfer.checked == false
    ) {
      toast.error("Please select one payment option!");
      return;
    }

    var paymentmode = "Cash";
    var paymentDetail = "";
    if (frmRef.current.cheque.checked) {
      paymentmode = "Cheque";
      paymentDetail = chequeDetails;
    }
    if (frmRef.current.bank_transfer.checked) {
      paymentmode = "Bank Transfer";
      paymentDetail = bankTransferDetails;
    }
    //console.log("Submit data");

    setLoading(true);

    const data = {
      paymentDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      directFarmerInvoiceId: directFarmerInvoiceId,
      warehouseId: localStorage.getItem("warehouseId"),
      supervisorEmployeeId: assignEmployeeId,
      totalbalanceAmount: frmRef.current.balanceAmount.value,
      paidAmount: frmRef.current.balanceAmount.value,
      paymentmode: paymentmode,
      paymentDetail: paymentDetail,
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };
    postDirectPayment(
      {
        url: "/api/directFarmerPayment/",
        method: directFarmerPaymentId ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success("Farmer payment  detail added");
        props.addForm(false)
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  // bank details
  const submitBankTransferDetails = (e) => {
    e.preventDefault();
    setBankTransferDetails((x) => [
      ...x,
      {
        srno:
          bankTransferDetails.length > 0
            ? bankTransferDetails[bankTransferDetails.length - 1].srno + 1
            : 1,

        accountNumber: bankTransferRef.current.account_number.value,
        accountHolderName: bankTransferRef.current.acc_holder_name.value,
        ifscCode: bankTransferRef.current.ifsc_code.value,
      },
    ]);

    //console.log(bankTransferDetails);
  };
  const handleDeleteBank = (index, e) => {
    setBankTransferDetails(bankTransferDetails.filter((v, i) => i !== index));
  };
  // bank details
  const submitChequeDetails = (e) => {
    e.preventDefault();
    setChequeDetails((x) => [
      ...x,
      {
        srno:
          chequeDetails.length > 0
            ? chequeDetails[chequeDetails.length - 1].srno + 1
            : 1,

        ChequeBankName: chequeRef.current.cheque_bank_name.value,
        ChequeNumber: chequeRef.current.cheque_number.value,
        ChequeBankAccountNumber:
          chequeRef.current.checque_bank_account_number.value,
      },
    ]);

    //console.log(chequeDetails);
  };
  const handleDeleteCheque = (index, e) => {
    setChequeDetails(chequeDetails.filter((v, i) => i !== index));
  };
  const handlePaymentMode = () => {
    if (frmRef.current.cheque.checked == true) {
      setChequeClose(true);
      setChequeDetails((items) => items.filter((x) => x.isSave));
    }
    if (frmRef.current.bank_transfer.checked == true) {
      setBankTransferClose(true);
      setBankTransferDetails((items) => items.filter((x) => x.isSave));
    }
  };

  return (
    <>
      {/* bank modal Start */}
      {bankTransferClose && (
        <Modal isOpen={bankTransferClose} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Bank Transfer Account Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setBankTransferClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <label htmlFor={"account_number"}>Account Number</label>
                <input
                  type={"input"}
                  id={"account_number"}
                  required
                  ref={(el) => (bankTransferRef.current["account_number"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"acc_holder_name"}>Acount Holder Name</label>
                <input
                  type={"input"}
                  id={"acc_holder_name"}
                  required
                  ref={(el) =>
                    (bankTransferRef.current["acc_holder_name"] = el)
                  }
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"ifsc_code"}>IFSC Code</label>
                <input
                  type={"input"}
                  id={"ifsc_code"}
                  required
                  ref={(el) => (bankTransferRef.current["ifsc_code"] = el)}
                  className="form-control"
                />
              </div>

              <div className="col-md-2">
                {" "}
                <br />
                <button
                  className="btn  btn-secondary mx-2 my-2"
                  onClick={submitBankTransferDetails}
                >
                  +
                </button>
              </div>
            </div>

            <hr />

            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                </tr>
              </thead>
              <tbody>
                {bankTransferDetails &&
                  bankTransferDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.srno}</td>
                        <td>{itm.accountNumber}</td>
                        <td>{itm.accountHolderName}</td>
                        <td>{itm.ifscCode}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDeleteBank(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            <div className="text-center">
              <div className="">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    bankTransferDetails.map((x) => (x["isSave"] = true));
                    setBankTransferClose(false);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* bank modal end */}

      {/* cheque modal */}

      {chequeClose && (
        <Modal isOpen={chequeClose} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Bank Transfer Account Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setBankTransferClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <label htmlFor={"cheque_bank_name"}>Cheque Bank Name</label>
                <input
                  type={"input"}
                  id={"cheque_bank_name"}
                  required
                  ref={(el) => (chequeRef.current["cheque_bank_name"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor={"cheque_number"}>Cheque Number</label>
                <input
                  type={"input"}
                  id={"cheque_number"}
                  required
                  ref={(el) => (chequeRef.current["cheque_number"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor={"checque_bank_account_number"}>
                  Cheque Bank Account No
                </label>
                <input
                  type={"input"}
                  id={"checque_bank_account_number"}
                  required
                  ref={(el) =>
                    (chequeRef.current["checque_bank_account_number"] = el)
                  }
                  className="form-control"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4"> </div>
              <div className="col-md-1"> </div>
              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={submitChequeDetails}
                >
                  +
                </button>
              </div>
              <div className="col-md-2"> </div>
              <div className="col-md-4"> </div>
            </div>

            <hr />

            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Cheque Bank Name</th>
                  <th>Cheque Number</th>
                  <th>Cheque Bank Account No</th>
                </tr>
              </thead>
              <tbody>
                {chequeDetails &&
                  chequeDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.srno}</td>
                        <td>{itm.ChequeBankName}</td>
                        <td>{itm.ChequeNumber}</td>
                        <td>{itm.ChequeBankAccountNumber}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDeleteCheque(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            <div className="row">
              <div className="col-md-4"> </div>
              <div className="col-md-1"> </div>
              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    chequeDetails.map((x) => (x["isSave"] = true));
                    setChequeClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-2"> </div>
              <div className="col-md-4"> </div>
            </div>
          </div>
        </Modal>
      )}

      {/* cheque modal end */}

      {/* Product modal end */}

      {close && (
        <Modal isOpen={close} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Product Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>
            <div>
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Crop Name </th>
                    <th>Variety Name</th>
                    <th>Grade</th>
                    <th>Item</th>
                    <th> Quantity</th>
                    <th>Unit</th>
                    <th>Rate</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {directFarmerInvoieProductdata &&
                    directFarmerInvoieProductdata.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{itm.cropName}</td>
                          {/* <td>{itm.itemDescription}</td> */}
                          <td>{itm.varietyName}</td>
                          <td>{itm.gradeName}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unitAbbreviation}</td>

                          <td>{itm.rate}</td>

                          <td>{itm.lineAmount}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Direct Farmer Payment Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>
                        {"Assigned Supervisor Employee"}
                      </label>
                      <select
                        id="emp_id"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Employee--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"gate_pass_id"}>
                        {"Farmer Invoice No"}
                      </label>

                      <select
                        id="emp_id"
                        required
                        className="form-control"
                        ref={(el) =>
                          (frmRef.current["directFarmerInvoiceId"] = el)
                        }
                        value={directFarmerInvoiceId}
                        onChange={(e) => {
                          setdirectFarmerInvoiceId(e.target.value);
                          loadprocurmentData(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Procurement Reciept No--
                        </option>
                        {directFarmerInvoiceData &&
                          directFarmerInvoiceData.map((x) => (
                            <option
                              key={x.directFarmerInvoiceId}
                              directFarmerInvoice-id={x.directFarmerInvoiceId}
                              value={x.directFarmerInvoiceId}
                            >
                              {x.directFarmerInvoiceNo}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"farmerName"}> {"Farmer Name"}</label>
                      <input
                        type={"text"}
                        id={"farmerName"}
                        required
                        ref={(el) => (frmRef.current["farmerName"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"getpassNo"}>{"Gate Pass No"}</label>
                      <input
                        type={"text"}
                        id={"getpassNo"}
                        readOnly
                        ref={(el) => (frmRef.current["getpassNo"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"procurementRecieptNo"}>
                        {"procurement Reciept No"}
                      </label>
                      <input
                        type={"text"}
                        id={"procurementRecieptNo"}
                        readOnly
                        ref={(el) =>
                          (frmRef.current["procurementRecieptNo"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"work_contact"}>{"Contact Number"}</label>
                      <input
                        type={"text"}
                        id={"contactnumber"}
                        required
                        ref={(el) => (frmRef.current["contactnumber"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />{" "}
                    </div>

                    <div className="col-md-4"></div>
                  </div>
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                      <div style={{ float: "right" }}>
                        <label>Note:All values are in {currencyCode}*</label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      <button
                        className="btn btn-secondary mx-2 my-2"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          setProductDetails((items) =>
                            items.filter((x) => x.isSave)
                          );
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"loadQuantity"}>{"Load Quantity"}</label>
                      <input
                        type={"text"}
                        id={"loadQuantity"}
                        required
                        ref={(el) => (frmRef.current["loadQuantity"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"totalAmount"}> {"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"totalAmount"}
                        readOnly
                        ref={(el) => (frmRef.current["totalAmount"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"advanceAmount"}>
                        {"Advance Amount Paid"}
                      </label>
                      <input
                        type={"text"}
                        id={"advanceAmount"}
                        readOnly
                        ref={(el) => (frmRef.current["advanceAmount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"balanceAmount"}>
                        {" "}
                        {"Amount to be Paid"}
                      </label>
                      <input
                        type={"text"}
                        id={"balanceAmount"}
                        readOnly
                        ref={(el) => (frmRef.current["balanceAmount"] = el)}
                        className="form-control"
                      />{" "}
                    </div>

                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-4">
                      <label>Farmer Payment Mode</label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="input-group mx-3">
                        <label htmlFor={"cash"}> {"Cash"}</label>
                        <input
                          type={"checkbox"}
                          id={"cash"}
                          ref={(el) => (frmRef.current["cash"] = el)}
                          className="form-check-input"
                          onClick={setCash}
                        />
                      </div>
                      <div className="input-group mx-3">
                        <label htmlFor={"cheque"}>{"Cheque"}</label>
                        <input
                          type={"checkbox"}
                          id={"cheque"}
                          ref={(el) => (frmRef.current["cheque"] = el)}
                          className="form-check-input"
                          onClick={handlePaymentMode}
                        />{" "}
                      </div>
                      <div className="input-group mx-3">
                        <label htmlFor={"bank_transfer"}>
                          {"Bank Transfer"}
                        </label>

                        <input
                          type={"checkbox"}
                          id={"bank_transfer"}
                          ref={(el) => (frmRef.current["bank_transfer"] = el)}
                          className="form-check-input"
                          onClick={handlePaymentMode}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-center">
                    <div className="">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default DirectFarmerPaymentForm;
